import React from 'react';
import { StarIcon, QuoteIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  name: 'Romina S.',
  age: 34,
  location: 'Córdoba',
  text: 'Siempre sentí que el Reiki era para mí, pero no encontraba un material claro. El Curso Integral me dio la estructura que necesitaba. Ahora practico todos los días con confianza.'
}, {
  name: 'Gabriela M.',
  age: 42,
  location: 'Rosario',
  text: 'Tenía miedo de no entender nada, pero todo está explicado tan simple que desde el primer tomo ya estaba practicando. Mis dolores de cabeza crónicos mejoraron muchísimo.'
}, {
  name: 'Soledad P.',
  age: 38,
  location: 'Buenos Aires',
  text: 'Lo compré pensando que era otro curso más, pero me sorprendió la profundidad y la claridad. Mis hijos notan la diferencia en casa. Estoy más tranquila y presente.'
}, {
  name: 'Mariana L.',
  age: 51,
  location: 'Mendoza',
  text: 'A mi edad pensé que era tarde para empezar algo nuevo. El Curso Integral me demostró lo contrario. Hoy doy sesiones a mis amigas y me siento realizada.'
}, {
  name: 'Florencia R.',
  age: 29,
  location: 'La Plata',
  text: 'Soy muy escéptica pero decidí probar. La guía de chakras fue reveladora. Entendí cosas de mi cuerpo y emociones que nunca había conectado.'
}];
export function TestimonialsSection() {
  const [ref1, vis1] = useReveal();
  const [ref2, vis2] = useReveal();
  return <section id="testimonials" className="bg-[#0f0f1a] py-14 md:py-20 px-4 border-t border-white/5" data-id="element-507">
      <div className="container mx-auto max-w-5xl" data-id="element-508">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-509">
          <div className="inline-flex items-center gap-2 text-[#f0c040] text-xs font-bold tracking-[0.3em] uppercase mb-4" data-id="element-510">
            <span className="w-8 h-px bg-[#f0c040]/40" data-id="element-511"></span>
            Historias reales
            <span className="w-8 h-px bg-[#f0c040]/40" data-id="element-512"></span>
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white leading-tight mb-4" data-id="element-513">
            Más de 500 alumnos ya están practicando Reiki con este método.
          </h2>
        </div>

        <div ref={ref2} className={`reveal grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 ${vis2 ? 'is-visible' : ''}`} data-id="element-514">
          {TESTIMONIALS.map((t, idx) => <div key={idx} className={`bg-[#252538] rounded-2xl p-6 shadow-sm border border-white/5 relative ${idx === TESTIMONIALS.length - 1 ? 'md:col-span-2 lg:col-span-1 md:max-w-md md:mx-auto lg:max-w-none lg:mx-0' : ''}`} data-id="element-515">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-white/5" data-id="element-516" />
              <div className="flex gap-1 mb-5" data-id="element-517">
                {[1, 2, 3, 4, 5].map(i => <StarIcon key={i} className="w-4 h-4 text-[#f0c040] fill-[#f0c040]" data-id="element-518" />)}
              </div>
              <p className="text-gray-300 text-lg leading-relaxed mb-4 font-medium" data-id="element-519">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4 pt-4 border-t border-white/10" data-id="element-520">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#d4a017] to-[#b8860b] flex items-center justify-center text-white font-bold text-sm shadow-sm" data-id="element-521">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-522">
                  <p className="font-bold text-white text-sm" data-id="element-523">
                    {t.name}, {t.age} años
                  </p>
                  <p className="text-xs text-gray-400 font-medium" data-id="element-524">
                    {t.location}, Argentina
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}